export default "__VITE_ASSET__BpWfpZtE__"